export default __webpack_public_path__ + "static/media/cover.97814b97.jpeg";